export default __webpack_public_path__ + "static/media/icon_document.04de8215.svg";